import { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { getCustomerData, signInCustomer, signOutCustomer } from "../helpers/httpRequests/auth";
import appToast from "../components/appToast";

export const AuthContext = createContext({});

function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [userName, setUserName] = useState(null);
    const [id, setId] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    async function loadSession({ silent } = {}) {
        try {
            const response = await getCustomerData();

            if (response && !response.error && response.data) {
                setIsAuthenticated(true);
                setUser(response.data);
                setUserName(response.data.complete_name);
                setId(response.data.id);
                return true;
            }

            if (response && response.error && !silent) {
                appToast.error(response.message);
            }
        } catch (error) {
            if (!silent) {
                appToast.error("Erro de conexão! Tente novamente mais tarde.");
            }
        }

        setIsAuthenticated(false);
        setUser(null);
        setUserName(null);
        setId(null);
        return false;
    };

    async function signIn(credentials) {
        setIsLoading(true);

        try {
            const response = await signInCustomer(credentials);

            if (response && response.error) {
                appToast.error(response.message);
            } else if (response && response.success) {
                await loadSession();
            } else {
                appToast.error("Erro de conexão! Tente novamente mais tarde.");
            }
        } catch (error) {
            appToast.error("Erro de conexão! Tente novamente mais tarde.");
        }

        setIsLoading(false);
    };

    async function signOut() {
        await signOutCustomer();
        setIsAuthenticated(false);
        setUser(null);
        setUserName(null);
        setId(null);
        localStorage.removeItem('ig_user_token');
        appToast.success("Até breve!")
    };

    useEffect(() => {
        localStorage.removeItem('ig_user_token');
        loadSession({ silent: true }).finally(() => setIsLoading(false));
    }, []);

    async function refreshUser() {
        await loadSession({ silent: true });
    }

    const contextValues = {
        user,
        id,
        token: null,
        userName,
        signOut,
        signIn,
        refreshUser,
        isAuthenticated,
        isLoading
    };

    return (
        <AuthContext.Provider
            value={contextValues}>
            {children}
        </AuthContext.Provider>
    );
};

const useAuth = () => useContext(AuthContext);

export { useAuth, AuthProvider };
